import "./scss/style.scss";
import "./scss/page.scss";
//alert('aaa')




let fixTop = 0;
const body = document.body;
const menuBtn = document.querySelector('.menu a');

// スクロール禁止関数
function disableScroll() {
  fixTop = window.scrollY;
  window.addEventListener("scroll", lockScroll, { passive: false });
}

// スクロール解除関数
function enableScroll() {
  window.removeEventListener("scroll", lockScroll, { passive: false });
}

// スクロール位置を固定する処理
function lockScroll(e) {
  window.scrollTo(0, fixTop);
}

menuBtn.addEventListener('click', function (e) {
  body.classList.toggle('side-open');
  e.preventDefault();
  
  this.classList.toggle('active');
  menuWrap.classList.toggle("on");

  if (this.classList.contains('active')) {
    disableScroll(); // スクロール禁止
  } else {
    enableScroll(); // スクロール解除
  }
});


let fired = false; // 発火したかどうかのフラグ
let active = false; // 今どっち側かを記録

const targets = document.querySelectorAll('.gColor img, .mSec');
const tHeader = document.querySelector(".hTop");

const mTpc = document.querySelector(".mTpc");
const menuWrap = document.querySelector(".menuWrap");

const fTop = document.querySelector(".fTop");


const hero = document.querySelector(".mainV");
if (hero) {
  setTimeout(function(){
    hero.classList.add("on");
    fTop.classList.add("on");
  },100)
  
}







let timers = [];

function clearTimers() {
  timers.forEach(id => clearTimeout(id));
  timers = [];
}


function onScroll() {


    if (scrollY > 10) {
      if (hero) {
      tHeader.classList.add("on");
      }
    } else {
      if (hero) {
      tHeader.classList.remove("on");
      }
      if (mTpc) {
        mTpc.classList.remove("on");
        menuWrap.classList.remove("on");
      }
    }
  




  const windowHeight = window.innerHeight;

  targets.forEach(el => {
    const rect = el.getBoundingClientRect();
    const elMid = rect.top + rect.height / 2;

    // 要素の中央が画面中央を越えたら .on 付与
    if (elMid < windowHeight * 0.9 && rect.bottom > 0) {
      el.classList.add('on');
    } else {
      el.classList.remove('on');
    }
  });
}


window.addEventListener('scroll', onScroll);
window.addEventListener('load', onScroll);



//pc用menu

/*
mTpc.addEventListener("click", (e) => {
  if (window.innerWidth < 769) return; // スマホでは何もしない
  e.preventDefault(); // リンクならデフォルト動作防止
  mTpc.classList.toggle("on");
  menuWrap.classList.toggle("on");
});


window.addEventListener("resize", () => {
  if (window.innerWidth < 769) {
    mTpc.classList.remove("on");
    //menuWrap.classList.remove("on");
  }
});
*/











window.addEventListener('beforeunload', () => {
  window.scrollTo(0,0);
});


window.scrollTo(0, 0);
//document.body.style.overflow = 'hidden';





// スムーススクロール処理
document.querySelectorAll('.ank1 a').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();

    const targetId = btn.getAttribute('href'); // ← 修正ポイント！
    const target = document.querySelector(targetId);

    const header = document.querySelector('header');
    const headerHeight = header ? header.offsetHeight : 0;
    const headerOffset = headerHeight + 20;

    if (target) {
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  });
});






// 高さ調整
let windowW = window.innerWidth;
let windowH = window.innerHeight;

function changeHeight() {
  const newWindowW = window.innerWidth;
  const newWindowH = window.innerHeight;

  // 幅か高さが変わった場合のみ更新
  if (newWindowW !== windowW || newWindowH !== windowH) {
    document.documentElement.style.setProperty('--vh', `${newWindowH * 0.01}px`);
    windowW = newWindowW;
    windowH = newWindowH;
  }
}

// 初回実行
changeHeight();

let timer = null;
window.addEventListener('resize', () => {
  if (timer !== null) clearTimeout(timer);

  timer = setTimeout(() => {
    changeHeight();
  }, 100);
});


//faqの仕様
document.querySelectorAll('.faqArea__Box--Q').forEach(moreBtn => {
  let isOpen = false;
  let isTransitioning = false; // ← 追加
  const content = moreBtn.nextElementSibling;

  moreBtn.addEventListener('click', () => {
    if (isTransitioning) return; // ← トランジション中は無視
    isTransitioning = true;

    if (!isOpen) {
      content.style.height = content.scrollHeight + 'px';
      content.classList.add('open');
      moreBtn.classList.add('on');
      isOpen = true;
    } else {
      content.style.height = content.scrollHeight + 'px'; // 一旦固定
      requestAnimationFrame(() => {
        content.style.height = '0px'; // ← 単位必須
        content.classList.remove('open');
        moreBtn.classList.remove('on');
        isOpen = false;
      });
    }
  });

  content.addEventListener('transitionend', (e) => {
    if (e.propertyName === 'height') {
      if (isOpen) {
        content.style.height = 'auto'; // 開いている時は高さを自動に戻す
        content.classList.add('open');
      }
      isTransitioning = false; // ← 完了したら解除
    }
  });
});



//spScの仕様
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.spSc').forEach(spSc => {
    let ticking = false;

    spSc.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          if (spSc.scrollLeft > 0) {
            spSc.classList.add('on');
          } else {
            spSc.classList.remove('on');
          }
          ticking = false;
        });
        ticking = true;
      }
    });
  });
});






import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener("DOMContentLoaded", () => {
  new Swiper('.swiper-container', {
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
});


